import { render, staticRenderFns } from "./TabPanelPerfilAcesso.vue?vue&type=template&id=12da75fd&"
import script from "./TabPanelPerfilAcesso.vue?vue&type=script&lang=js&"
export * from "./TabPanelPerfilAcesso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports